import React, { forwardRef, useEffect, useState } from 'react';
import { InvoiceDto } from '../../../models/invoice.dto';
import DatePicker from 'react-datepicker';
import { useUpdateInvoiceMutation } from '../../../store/invoices/invoices.api';
import paymentDateCalendar from '../../../assets/icons/payment-date-calendar.svg';
import './action-dropdown.scss';

interface PropsType {
   invoice: InvoiceDto;
}

interface PaymentDateButtonProps {
   value?: string;
   onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

export const PaymentDateButton = forwardRef<HTMLButtonElement, PaymentDateButtonProps>(
   ({ value, onClick }, ref) => (
      <button ref={ref} type='button' className='toggle-menu-button payment-date-field' onClick={onClick}>
         <span>{value}</span>
         <span className='payment-date-calendar' aria-hidden='true'>
            <img src={paymentDateCalendar} alt='' />
         </span>
      </button>
   )
);

PaymentDateButton.displayName = 'PaymentDateButton';

const PaymentDateField = ({
   invoice
} :PropsType) => {
   const [paymentDate, setPaymentDate] = useState<Date | null>(
      invoice.paymentDate ? new Date(invoice.paymentDate) : null,
   );
   const [updateInvoice] = useUpdateInvoiceMutation();

   useEffect(() => {
      setPaymentDate(invoice.paymentDate ? new Date(invoice.paymentDate) : null);
   }, [invoice.paymentDate]);

   const handlePaymentDateChange = (date: Date | null) => {
      if (!date) return;

      setPaymentDate(date);
      updateInvoice({
         invoiceId: invoice.invoiceId,
         data: { ...invoice, paymentDate: date.toISOString() },
      });
   };

   return (
      <DatePicker
         selected={paymentDate}
         onChange={handlePaymentDateChange}
         dateFormat='dd-MM-yyyy'
         popperPlacement='top-end'
         popperModifiers={[{ name: 'flip', enabled: false }]}
         popperClassName='payment-date-popper'
         wrapperClassName='payment-date-picker'
         customInput={<PaymentDateButton />}
      />
   );
};

export default PaymentDateField;
